import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ZarinPal from '../../assets/images/zarinPal-1.png';
import SamanBank from '../../assets/images/saman-bank-logo.png';
import MeliBank from '../../assets/images/meli-bank-logo.png';
import { numToPrice, pexios, toast } from '../../utils/functions';
import { setRouterData } from '../../redux/actions';
import { history } from '../../utils/variables';
import { toast as toast2 } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { TitleContext } from '../../App';
export default function Receipt() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user ,location} = useSelector(store => store);
    const constantPay = 2937500;
    const tax_pay_constant = parseInt(0.09*constantPay)
    const total_price = constantPay + tax_pay_constant;
    const [selected,setSelected] = useState(0)
    // const {setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //   setTitle('کیف پول')
    // },[])
    function handlerPay() {
          if(user.my_wallet){
            if(user.my_wallet.total_left < total_price)
            pexios('api/request_charge_wallet','post', {cost : (total_price - user.my_wallet.total_left)})
            .then(res=>{
              if(res.data.url) 
               window.location.href = res.data.url
            }).catch(err=>{
              toast(`${t('Code')}  ${err.response.data.error.code}  : ${err.response.data.error.message}`,'error') 
            })
            else {
              requestAccident()
            }
          }else{
            pexios('api/request_charge_wallet','post',{cost: total_price})
            .then(res=>{
              if(res.data.url) 
               window.location.href = res.data.url
            }).catch(err=>{
              toast(`${t('Code')}  ${err.response.data.error.code}  : ${err.response.data.error.message}`,'error') 
            })
          }
       }
       function requestAccident (){
        pexios('/api/request_new_accident', 'post', location)
            .then(res => {
                const { msg, redirection_link, status, id} = res.data;
                if (msg) {
                    toast(msg, status);
                }
                if (redirection_link) {
                    history.push(redirection_link);
                    return;
                }
                dispatch(setRouterData({id: id, type: 'accident'}));
                history.push('/waiting');
            });
   }
    return(
        <div className='content receipt'>
          <p className='text-center receipt-title'>{t('Payment invoice')}</p>
          <div className='receipt-modal boredr-bottom'>
            <div className='d-flex space-between align-items-center'>
              <p >{numToPrice(constantPay)} {t('rial')}</p>
              <p>{t('The cost of assessments')} :</p> 
            </div>
            <div className='d-flex space-between align-items-center'>
              <p>{numToPrice(tax_pay_constant)} {t('rial')}</p>
              <p>{t('Tax')} :</p>
            </div>
            <div className='d-flex space-between align-items-center border-bottom pb20'>
              <p style={user.my_wallet?.total_left < 0 ? {color: 'red'} : {}}>{numToPrice(user.my_wallet?.total_left)} {t('rial')}</p>
              <p>{t('Your wallet stock')} :</p>
            </div>
            <div className='d-flex space-between align-items-center pt10 pb10 total-price'>
              <p> { numToPrice(total_price - (user.my_wallet ? user.my_wallet?.total_left : 0))} {t('rial')}</p>
              <p>{t('Final amount payable')} :</p>
            </div>
          </div>
          <p className='mt20 mr10 border-bottom text-center pb10'>{t('Payment gateways')}</p>
          <div className='dargah-image'>
            <div className={`dargah-logo ${selected === 2 ? 'selected':'grey-img'}`} 
              onClick={()=>{
                toast2.dismiss();
                setSelected(2)
                toast(t('This gateway is unavailable, use another one'),'error');
              }
              }
              >
              <img src={SamanBank} alt="dargah" />
            </div>
            <div className={`dargah-logo ${selected === 1 ? 'selected':'grey-img'}`} 
              onClick={()=>{
                toast2.dismiss();
                setSelected(1)
                toast(t('This gateway is unavailable, use another one'),'error');
              }}
            >
              <img src={MeliBank} alt ="dargah"/>
            </div>
            <div className={`dargah-logo ${selected === 0 ? 'selected':'grey-img'}`} 
              onClick={()=>{
                toast2.dismiss();
                setSelected(0)
              }}
              >
              <img src={ZarinPal} alt="dargah"/>
            </div>
          </div>
            <button className='btn btn-block btn-green btn-circle mb10' 
            onClick={handlerPay}
            disabled={selected !== 0 ? true : false}
            
            >
              {t('Pay')}
            </button>
         </div>
    )

}